
export class AssetAbridged {
  id: number;
  name: string;

  public deserialize(input: any): this {
    this.id = input.id;
    this.name = input.name;

    return this;
  }
};
